import { useRef, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { GuideHeader } from "./GuideHeader";
import "./guide.css"
import { CardUniv } from "./CardUniv";
import Logo from '../Assets/logo.webp'
import { ReactComponent as Back } from "../Assets/guide/back-btn.svg";
import { thisYear } from "../Footer/footer";
import { FaArrowUp } from "react-icons/fa";

export const GuideCity = () => {
  const { city } = useParams(); // dari route: /guide/:city
  const bgRef = useRef(null);
  const listRef = useRef(null);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleWindowScroll = () => {
      const windowScroll = window.scrollY || document.documentElement.scrollTop;
      if (windowScroll > 300) {
        setShowScrollTop(true);
      } else {
        const bgScroll = bgRef.current ? bgRef.current.scrollTop : 0;
        const listScroll = listRef.current ? listRef.current.scrollTop : 0;
        if (bgScroll <= 300 && listScroll <= 300) {
          setShowScrollTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleWindowScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleWindowScroll);
  }, []);

  const handleScroll = () => {
    const bgScroll = bgRef.current ? bgRef.current.scrollTop : 0;
    const listScroll = listRef.current ? listRef.current.scrollTop : 0;
    const windowScroll = window.scrollY || document.documentElement.scrollTop;

    if (bgScroll > 300 || listScroll > 300 || windowScroll > 300) {
      setShowScrollTop(true);
    } else {
      setShowScrollTop(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (bgRef.current) {
      bgRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (listRef.current) {
      listRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <>
      <div
        ref={bgRef}
        onScroll={handleScroll}
        className="bg container default"
      >
        <GuideHeader />
        <div className="overflow-hidden position-absolute top-0 start-50 translate-middle-x guide-body">
          <Link to={"/guide"}>
            <Back className="btn-back" />
          </Link>
          <div className="header-wrapper text-center wef-font mb-4">
            <div className="heading-img mb-1" />
            {/* <div className="city" data-city={city.toLowerCase()}> */}
            <div className="city-guide">
              <p>{city.toUpperCase()}</p>
            </div>
          </div>
          <div
            ref={listRef}
            onScroll={handleScroll}
            className="overflow-auto"
            style={{ width: '100vw', height: '650px' }}
          >
            <CardUniv />
          </div>
          <button
            onClick={scrollToTop}
            className={`btn-scroll-top ${showScrollTop ? 'show' : ''}`}
            aria-label="Back to top"
          >
            <FaArrowUp />
          </button>
        </div>
      </div>
      <section>
        <div className="col-lg-12">
          <div className="copyright-guide container">
            <div className="logo mx-auto">
              <a href="/">
                <img
                  src={Logo}
                  alt="logo"
                  width="60"
                  height="38"
                />
              </a>
            </div>

            <p>
              <br />
              © {thisYear} <a href="https://niecindonesia.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'black', fontWeight: 600 }}>NIEC Indonesia</a>. All Rights Reserved. CV Naresy Indonesia <br />Designed by NIEC IT Team
            </p>
          </div>
        </div>
      </section>
    </>
  )
}